var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('p',{directives:[{name:"localize",rawName:"v-localize"}]},[_vm._v("This job is currently running.")])])}
var staticRenderFns = []

export { render, staticRenderFns }